
import { City, CityPoint } from "@/models/City";
import StringHelper from "@/utils/StringHelper";
import { MapOptions } from "@/models/Map";
import { Component, Vue, Prop } from "vue-property-decorator";
import Map from "../Base/Map.vue";
import { forIn } from "lodash";
import { Validations } from "vuelidate-property-decorators";
import { required, minLength, maxLength } from "vuelidate/lib/validators";

@Component({
  components: { Map },
})
class AddLocation extends Vue {
  @Prop({ default: "" }) readonly cityData!: City;
  displayName = "";
  notes = "";
  place: any = {};
  errorMessage = "";
  lat = 0;
  lng = 0;

  get getSlugifyName(): string {
    return StringHelper.Slugify(this.displayName);
  }

  get centerPoint(): any {
    return { latitude: this.lat, longitude: this.lng };
  }
  created(): void {
    this.displayName = "";
    this.lat = this.cityData.centre_point.latitude;
    this.lng = this.cityData.centre_point.longitude;
    this.$v.$touch();
  }
  cancel(): void {
    this.$emit("closeDialog");
  }
  saveLocation(): void {
    if (this.cityData.locations[this.getSlugifyName] !== undefined) {
      this.errorMessage = "An city with the same slug already exists.";
      this.$bvModal.show("modal-sm");
    } else {
      if (this.displayName.length > 0 && /[a-z]/i.test(this.displayName)) {
        const cityPoint: CityPoint = {
          slug: this.getSlugifyName,
          name: { en: this.displayName },
          notes: this.notes,
          lat_long: {
            latitude: this.place.latitude,
            longitude: this.place.longitude,
          },
        };
        this.$store
          .dispatch("cityStore/insertNewLocation", {
            city: this.cityData.slug,
            cityPoint: cityPoint,
          })
          .then((results) => {
            if (results === "success") {
              this.$emit("closeDialog");
            } else {
              //display erorr
              console.log(results);
            }
          });
      } else {
        this.$bvModal.show("modal-sm");
        this.errorMessage =
          "Please make sure the display name is not empty and contains at least one letter";
      }
    }
  }
  get getCityMarkerPoints(): MapOptions[] {
    var arr = [];
    var cityCentreMarker: MapOptions = {
      position: {
        lat: this.lat,
        lng: this.lng,
      },
      title: "MapMarker",
      draggable: true,
      clickable: false,
      slug: "",
      zIndex: 1000,
      radius: 10,
    };
    arr.push(cityCentreMarker);
    forIn(this.cityData.locations, (val: CityPoint) => {
      if (val.slug !== "centre_point") {
        var locationMarker: MapOptions = {
          position: {
            lat: val.lat_long.latitude,
            lng: val.lat_long.longitude,
          },
          title: val.name.en,
          slug: val.slug,
          draggable: false,
          clickable: true,
          zIndex: 100,
          radius: 10,
          icon: require("@/assets/images/map/city-gray.svg"),
        };

        arr.push(locationMarker);
      }
    });
    return arr;
  }

  mapData(place: any): void {
    this.place = place;
    this.lat = place.latitude;
    this.lng = place.longitude;
  }

  @Validations()
  validations = {
    displayName: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(160),
    },
  };
}

export default AddLocation;
